module.exports = __webpack_public_path__ + "img/clerk_incoming_goods_2.840d4557.png";